import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Couimg from "../assets/img/oneimg1.png";
import Couimgg from "../assets/img/oneimg2.png";
import Image1 from "../assets/img/courtest1.png";
import Image2 from "../assets/img/courtest4.png";
import Image3 from "../assets/img/courtest3.png";
import Image4 from "../assets/img/courtest2.png";

import Video1 from '../assets/video/video1.mp4';
import Video2 from '../assets/video/video2.mp4';
import Video3 from '../assets/video/video3.mp4';
import Video4 from '../assets/video/video4.mp4';
import Gmailicon from '../assets/img/gmail.png';
import Phoneicon from '../assets/img/phone.png';
import Playbtn from '../assets/img/play.png';
import Fiveday from '../assets/img/five_days.jpg';

import onebg from '../assets/img/one/daybg.jpg';
import Icon1 from '../assets/img/one/icon1.png';
import Icon2 from '../assets/img/one/icon2.png';
import Icon3 from '../assets/img/one/icon3.png';
import Icon4 from '../assets/img/one/icon4.png';

import Icon5 from '../assets/img/one/icon5.jpg';
import Icon6 from '../assets/img/one/icon6.jpg';
import Icon7 from '../assets/img/one/icon7.jpg';
import Icon8 from '../assets/img/one/icon8.jpg';
import Icon9 from '../assets/img/one/icon9.jpg';
import Icon51 from '../assets/img/icon51.png';
import Icon61 from '../assets/img/icon61.png';
import Icon71 from '../assets/img/icon71.png';
import Icon81 from '../assets/img/icon81.png';
import Icon91 from '../assets/img/icon91.png';

import imgcha from '../assets/img/one/img2.png';
import imgcha1 from '../assets/img/one/five_days.png';

import SeoHelmet from "../components/SeoHelmet";
import iconstrt from "../assets/img/iconstartt.png";
import CommonModal from "../components/CommonModal";

import RazorpayModal from "../components/RazorpayModal";
import staricon from '../assets/img/starbtn.png';

const Fivedays = () => {
 

const [activeVideo, setActiveVideo] = useState(null);
const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: ""
});

    
      const handleOpenModal = (videoSrc) => {
        setActiveVideo(videoSrc); // Set the active video source
      };
    
      const handleCloseModal = () => {
        setActiveVideo(null); // Clear the active video source
      };

     


      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      };


 

  

  useEffect(() => {
       
    if (window.Swiper) {
      
     

      const swiper = new window.Swiper(".coursesslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 3, 
            spaceBetween: 30,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },
          },
          // You can add more breakpoints if needed
        },
      
      });
       
     
    }
  }, []); 


  return (
    <>
 <SeoHelmet />
<CommonModal id="staticBackdrop" />

    <section className="oneofone_section fivedys five_days" style={{ backgroundImage: `url(${onebg})` }}>
      <div class="container">
        <div className="contentone_outer">
          <div className="title_one">
            <h4>Transform Yourself in 5 Days</h4>
            <h2>Live Online Workshop</h2>
          </div>
          <div className="skillbox">
              <ul>
                <li><img src={Icon1}></img><spna>Learn From Home, <br></br>Live Guidance</spna></li>
                <li><img src={Icon2}></img><spna>Simple Language, <br></br>Easy to Follow</spna></li>
                <li><img src={Icon3}></img><spna>4 Hours Session, <br></br>Everyday</spna></li>
                <li><img src={Icon4}></img><spna>Ask Questions, <br></br>Get Real-Time Feedback</spna></li>
              </ul>
              
          </div>
          <div className="skillbox_content">
              <h3>At the End of the Course You Will Have </h3>
              <p>The personal style, the body language and the skills to show up stronger every day -<br></br> at work, in social meets, and in your personal life</p>
          </div>
          <div className="onedetails">
              <div className="details_col">
                  <h2>Details:</h2>
                   <ul>
                      <li><h4>Duration</h4><spna>5 Days</spna></li>
                      <li><h4>location</h4><spna>Live Online Sessions</spna></li>
                      <li><h4>fees</h4><spna> ₹49,999/-</spna></li>
                    </ul>
                    <a href="#" data-bs-toggle="modal" data-bs-target="#onlineModal"className="terrs_btn btnenroll">
                      <img src={staricon} alt="" />ENROLL NOW</a>
              </div>
              <div className="details_col-con">
                <div className="days_box">
                  <h3><p>Day<span>01</span></p>Knowing Yourself Better</h3>
                  <div className="daytext">
                     <p><b>.</b> Self Understanding: Know your strengths and weak areas</p>
                     <p><b>.</b> Confidence Start: Learn how to believe in yourself</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>02</span></p>Making a Good Impression</h3>
                  <div className="daytext">
                     <p><b>.</b> First Impression: Learn how to stand out naturally</p>
                     <p><b>.</b> Positive Energy: Make people feel comfortable around you</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>03</span></p>Finding Your Style</h3>
                  <div className="daytext">
                     <p><b>.</b> Right Dressing: Know what clothes suit you best</p>
                     <p><b>.</b> Simple Wardrobe: Dress smart without confusion</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>04</span></p>Speaking with Confidence</h3>
                  <div className="daytext">
                     <p><b>.</b> Clear Talking: Speak clearly and with confidence</p>
                     <p><b>.</b> Better Voice: Improve your tone and way of speaking</p>
                  </div>
                </div>
                <div className="days_box">
                  <h3><p>Day<span>05</span></p>Body Language Basics</h3>
                  <div className="daytext">
                     <p><b>.</b> Confident Posture: Stand, walk, and sit confidently</p>
                     <p><b>.</b> Eye Contact: Use body language to show confidence</p>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>

    <section className="whycho">
      <div className="onembr_row">
        <div className="imageoner five_image">
          <img className="imageonerr1" src={imgcha} ></img>
           <img className="imageonerr2" src={imgcha1} ></img>
        </div>
        <div className="contentoner">
          <h2>Why<br></br>Choose This Course</h2>
          <ul>
            <li><img className="num" src={Icon5} ></img><img className="num1" src={Icon51} ></img><span>Live Expert Guidance: Learn directly from Bhavana in focused sessions</span></li>
            <li><img className="num" src={Icon6} ></img><img className="num1" src={Icon61} ></img><span>Access From Home: Build confidence and skills without relocation.</span></li>
            <li><img className="num" src={Icon7} ></img><img className="num1" src={Icon71} ></img><span>Fast-Tracked Learning: Learn what normally takes years of trial.</span></li>
            <li><img className="num" src={Icon8} ></img><img className="num1" src={Icon81} ></img><span>No Guesswork: Clear frameworks, not random motivation.</span></li>
            <li><img className="num" src={Icon9} ></img><img className="num1" src={Icon91} ></img><span>Beyond Motivation: Real tools, not temporary inspiration</span></li>
          </ul>
         <div className="btngroup">
                <a
                  href="/two-week-transformation"
                  className="terrs_btn" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                >
                  <img src={iconstrt} alt="" />
                  Get In Touch
                </a>
               <a
  href="#"
  data-bs-toggle="modal"
  data-bs-target="#onlineModal"
  className="terrs_btn"
>
  <img src={iconstrt} alt="" />
  ENROLL NOW
</a>
              </div>
        </div>
      </div>
    </section>

    <RazorpayModal
  id="onlineModal"
  title="Pay for Online Course"
  courseType="online"
/>
      
    </>
  );
};

export default Fivedays;
